<template>
  <v-card class="elevation-12">
    <MailsDataTable
        :loading="loading"
        :mails="mails"
        :total="total"
        :allowed-page="true"
        :allowed-unit-page="true"
        @update="onUpdate"
    />
  </v-card>
</template>

<script>

import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP, LAYOUT_TITLE_CHANGED} from "@/store/modules/layout/actions";
import Moment from "moment";
import MailsDataTable from "@/components/mail/MailsDataTable";
import _ from 'underscore'
import Mapper from '../../mappers'
import MailService from '../../services/mail.service'

export default {
  name: "ModeratorMailsPage",
  components: {
    MailsDataTable
  },
  data() {
    return {
      mails: [],
      total: 0,
      loading: false,
    }
  },
  methods: {
    reloadMails(options, filters) {
      this.loading = true;
      this.$store.dispatch(LAYOUT_LOADING_START)

      const {sortBy, sortDesc, page, itemsPerPage} = options;
      const {inn, unitId, receiver, region, area, start, end, sendFrom, sendEnd, performType, isPerformed} = filters;

      const skip = (page - 1) * itemsPerPage;

      MailService.get({
        skip: skip,
        limit: itemsPerPage,
        sort: sortBy.length === 1 ? sortBy[0] : null,
        desc: sortDesc.length === 1 ? sortDesc[0] : null,
        inn: inn,
        unitId: unitId,
        receiver: receiver,
        region: region,
        area: area,
        createdStart: start ? Moment(start, 'YYYY-MM-DD') : null,
        createdEnd: end ? Moment(end, 'YYYY-MM-DD') : null,
        sentStart: sendFrom ? Moment(sendFrom, 'YYYY-MM-DD') : null,
        sentEnd: sendEnd ? Moment(sendEnd, 'YYYY-MM-DD') : null,
        performType: performType,
        isPerformed: isPerformed
      })
          .then(response => {
            this.mails = _.map(response.data.Records, mailViewModel => {
              return Mapper.mapMail(mailViewModel)
            })
            this.total = response.data.Total;
          }, () => {

          })
          .finally(() => {
            this.loading = false;
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },
    onUpdate(options, filters) {
      this.reloadMails(options, filters)
    }
  },
  created() {
    this.$store.dispatch(LAYOUT_TITLE_CHANGED, this.$t('moderatorMailsPage.pageTitle'))
  }
}
</script>

<style scoped>

</style>